import { Provider } from '@angular/core';
import { CORE_RUNTIME_CONFIG } from './core-config.token';
import { CoreRuntimeConfigOverride, resolveCoreRuntimeConfig } from './core-config';

export function provideCoreConfig(config?: CoreRuntimeConfigOverride): Provider {
  return {
    provide: CORE_RUNTIME_CONFIG,
    useValue: resolveCoreRuntimeConfig(config),
  };
}
